import {formatter, request} from '@/utils/request';

export namespace Supplier {
  export const Path = {
    Query: '/expenseapi/supplier/query',
    Search: '/expenseapi/supplier/search',
    AjaxSearch: '/expenseapi/supplier/ajaxSearch',
    Get: '/expenseapi/supplier/get',
    Export: "/expenseapi/supplier/export",
    QuerySupplierCompany: "/expenseapi/supplier/querySupplierCompany",
    GetSupplier: "/expenseapi/supplier/getSupplier",
  };

  export async function query(body: any) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.QueryResult<API.QueryForSupplierData>>(Path.Query, formatter(options),);
  }

  export async function get(id: number) {
    const options = {
      method: 'GET',
      body: {
        id: id,
      },
    };
    return request<API.ResponseResult<API.Supplier>>(Path.Get, formatter(options));
  }

  export async function search(body: API.SupplierFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Supplier[]>>(Path.Search, formatter(options));
  }

  export async function ajaxSearch(body: API.SupplierFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Supplier[]>>(Path.AjaxSearch, formatter(options));
  }

  export async function exportEx(body: any) {
    const param = {
      method: 'POST',
      body: {
        "id": "Supplier",
        ...body
      }
    }
    return request<API.ResponseResult<any>>(Path.Export, formatter(param));
  }

  export async function querySupplierCompany(body: API.SupplierFilter) {
    const options = {
      method: 'POST',
      body: {
        ...body
      },
    };
    return request<API.ResponseResult<API.Supplier[]>>(Path.QuerySupplierCompany, formatter(options));
  }

  export async function getSupplier(supplierId?:number,companyCode?:string,isActive?:boolean) {
    const options = {
      method: 'GET',
      body: {
        supplierId: supplierId,
        companyCode: companyCode,
        isActive: isActive
      },
    };
    return request<API.ResponseResult<API.SupplierAndCompany>>(Path.GetSupplier, formatter(options));
  }
}
